/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { TeamDiaryData } from '../models/TeamDiaryData';
import type { TeamDiaryDto } from '../models/TeamDiaryDto';
import type { TeamDiaryItemType } from '../models/TeamDiaryItemType';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class TeamDiaryService {

  /**
   * @param dateFrom 
   * @param dateTo 
   * @param userId 
   * @param employeeName 
   * @param branchId 
   * @param departmentId 
   * @returns TeamDiaryDto Success
   * @throws ApiError
   */
  public static getApiTeamDiary(
dateFrom?: string,
dateTo?: string,
userId?: number,
employeeName?: string,
branchId?: number,
departmentId?: number,
): CancelablePromise<Array<TeamDiaryDto>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/TeamDiary',
      query: {
        'DateFrom': dateFrom,
        'DateTo': dateTo,
        'UserId': userId,
        'EmployeeName': employeeName,
        'BranchId': branchId,
        'DepartmentId': departmentId,
      },
    });
  }

  /**
   * @param id 
   * @returns any Success
   * @throws ApiError
   */
  public static deleteApiTeamDiary(
id?: number,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/api/TeamDiary',
      query: {
        'id': id,
      },
    });
  }

  /**
   * @param formData 
   * @returns boolean Created
   * @throws ApiError
   */
  public static postApiTeamDiary(
formData?: {
Id?: number;
TypeId: TeamDiaryItemType;
UserId: number;
Description?: string;
DateFrom: string;
DateTo: string;
},
): CancelablePromise<boolean> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/TeamDiary',
      formData: formData,
      mediaType: 'multipart/form-data',
    });
  }

  /**
   * @param startDate 
   * @param dateTo 
   * @returns boolean Success
   * @throws ApiError
   */
  public static putApiTeamDiary(
startDate?: string,
endDate?: string,
): CancelablePromise<boolean> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/api/TeamDiary',
      query: {
        'startDate': startDate,
        'endDate': endDate,
      },
    });
  }

  /**
   * @param id 
   * @returns TeamDiaryData Success
   * @throws ApiError
   */
  public static getApiTeamDiaryGetById(
id?: number,
): CancelablePromise<TeamDiaryData> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/TeamDiary/get-by-id',
      query: {
        'id': id,
      },
    });
  }

}
